import _ from 'lodash';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const formatDayWithUtc = (milliseconds: number, format: string) => {
  const date = new Date(milliseconds).toUTCString();
  return dayjs.utc(date).format(format);
};

export const formatDay = (milliseconds: number, format: string) => {
  const date = new Date(milliseconds);
  return dayjs(date).format(format);
};

export const isWeekend = (milliseconds: number) => {
  const date = new Date(milliseconds).toUTCString();
  const day = dayjs.utc(date).format('d');
  return +day === 0 || +day === 6;
};

// Convert date from & until to an array of milliseconds
export const dateArray = (from?: string, to?: string) => {
  const datePoints: number[] = [];
  if (from && to) {
    const dateFrom = Date.parse(from);
    let dateTo = Date.parse(to);
    while (dateTo >= dateFrom) {
      datePoints.push(dateTo);
      dateTo -= 86400000;
    }
  }
  return datePoints;
};

export const calcPercent = (point: { expected: number; real: number }) => {
  const result = point.real / point.expected;
  return point.expected === 0 ? 'x' : (result * 100).toFixed(1);
};

type AccessTablePoint = [string, number, number, number, number];

type AccessTableRow = {
  points: AccessTablePoint[];
};

type AccessTableSource = {
  rows?: AccessTableRow[];
};

export const getAccessCellValues = (
  source: AccessTableSource | undefined,
  day?: number,
) => {
  let points = _.flatten(_.map(source?.rows, 'points')) as AccessTablePoint[];
  if (day) points = points.filter((point) => Date.parse(point[0]) === +day);
  return {
    expected: _.sumBy(points, '1'),
    real: _.sumBy(points, '2'),
    incomplete: _.sumBy(points, '3'),
  };
};

export const ALL_CONTRACTORS_ID = -1;

/* eslint-disable max-len */
export const displayRow = (placementId: number, clickedRows: number[]) => _.includes(clickedRows, placementId);
